module.exports = __webpack_public_path__ + "static/media/icon_camera.16dbea87.svg";